module.exports = __webpack_public_path__ + "font_uzura.486a5a6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/font_uzura.png
// module id = aw46
// module chunks = 0